import { createContext, createElement, useContext } from 'react';

if (!globalThis.njThemeContext) {
    globalThis.njThemeContext = createContext({
        locale: 'en',
        renderLink: () => createElement('a'),
    });
}
const NinjaThemeContext = globalThis.njThemeContext;
NinjaThemeContext.displayName = 'NinjaThemeContext';
const InternalNinjaThemeContextProvider = NinjaThemeContext.Provider;
const useWebUIConfigOptions = () => {
    const options = useContext(NinjaThemeContext);
    return Object.assign(Object.assign({}, options), { isRtlLocale: options.locale === 'ar' });
};

export { InternalNinjaThemeContextProvider, useWebUIConfigOptions };
